export default __webpack_public_path__ + "static/Floorplan_PH4AR-UL_v1-fb216755f9ef5e43cdb1ab1ba5da1d08.svg";